<template>
	<div class="login-container">
		<!-- Left Panel - Branding -->
		<div class="left-panel">
			<div class="branding-content">
				<div class="logo-section">
					<img
						src="images/final_elephant.png"
						alt="Speke Holidays"
						class="brand-logo"
					/>
					<h1 class="brand-title">Speke Holidays</h1>
					<p class="brand-subtitle">Uganda's Premier Safari Experience</p>
				</div>

				<div class="features-section">
					<div
						class="feature-item"
						v-for="(feature, index) in features"
						:key="index"
					>
						<div class="feature-icon">
							<i :class="feature.icon"></i>
						</div>
						<div class="feature-text">
							<h3>{{ feature.title }}</h3>
							<p>{{ feature.description }}</p>
						</div>
					</div>
				</div>

				<div class="decorative-elements">
					<div class="circle circle-1"></div>
					<div class="circle circle-2"></div>
					<div class="circle circle-3"></div>
				</div>
			</div>
		</div>

		<!-- Right Panel - Login Form -->
		<div class="right-panel">
			<div class="login-form-container">
				<div class="form-header">
					<h2 class="form-title">Welcome Back</h2>
					<p class="form-subtitle">
						Sign in to access your management dashboard
					</p>
				</div>

				<form class="login-form" @submit.prevent="loginUser()">
					<div class="form-group">
						<label for="email" class="form-label">Username</label>
						<div v-if="login.errors.has('email')" class="error-message">
							{{ login.errors.get("email") }}
						</div>
						<v-text-field
							density="comfortable"
							id="email"
							v-model="login.email"
							placeholder="Enter your username"
							prepend-inner-icon="mdi-account-outline"
							variant="outlined"
							class="modern-input rounded-0"
						></v-text-field>
					</div>

					<div class="form-group">
						<label class="form-label">Password</label>
						<div v-if="login.errors.has('password')" class="error-message">
							{{ login.errors.get("password") }}
						</div>
						<v-text-field
							:append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
							:type="visible ? 'text' : 'password'"
							density="comfortable"
							id="password"
							v-model="login.password"
							placeholder="Enter your password"
							prepend-inner-icon="mdi-lock-outline"
							variant="outlined"
							class="modern-input rounded-0"
							@click:append-inner="visible = !visible"
						></v-text-field>
					</div>

					<div class="form-options">
						<label class="remember-me">
							<input type="checkbox" v-model="rememberMe" />
							<span>Remember me</span>
						</label>
						<a href="#" class="forgot-link">Forgot password?</a>
					</div>

					<button type="submit" class="login-button">
						<span>Sign In</span>
						<i class="mdi mdi-arrow-right"></i>
					</button>
				</form>

				<div class="form-footer">
					<p class="system-info">Speke Management System v2.0</p>
				</div>
			</div>
		</div>
	</div>
</template>



<script>
import { Form } from "vform";
// import axios from "axios";
// axios.defaults.withCredentials = true;

import cookies from "js-cookie";
import config from "../config/settings.js";

import encryption from "hashids";

export default {
	name: "Login",

	data() {
		return {
			api: config.API_URL,
			prefix: config.API_PFX,
			registerOpen: "false",
			passwordOpen: "false",
			visible: false,
			rememberMe: false,
			message: "",
			user: [],
			http_code: "",
			errors: [],
			features: [
				{
					icon: "mdi mdi-map-marker-radius",
					title: "Tour Management",
					description: "Comprehensive safari tour planning and tracking",
				},
				{
					icon: "mdi mdi-car-multiple",
					title: "Fleet Control",
					description: "Real-time vehicle and asset management",
				},
				{
					icon: "mdi mdi-chart-line",
					title: "Analytics",
					description: "Detailed insights and performance metrics",
				},
			],
			register: new Form({
				FirstName: "",
				MiddleName: "",
				Surname: "",
				CraneUserName: "",
				LoginID: "",
				UserEMailAddress: "",
				UserPassword: "",
				EntityMobileTelephone: "",
				InteractionEntityName: "",
				ModifiedBy: "",
			}),
			login: new Form({
				email: "",
				password: "",
			}),
			reset: new Form({
				UserEMailAddress: "",
			}),
		};
	},
	methods: {
		cacheUser() {
			this.$router.push("/dash");
		},
		getCookie() {
			let token = cookie.get("XSRF-TOKEN");
			if (token) {
				return new Promise((resolve) => {
					resolve(token);
				});
			} else {
				return axios.get(this.api + "/csrf-cookie");
			}
		},
		setAuth(key, value, ttl) {
			const now = new Date();

			// `item` is an object which contains the original value
			// as well as the time when it's supposed to expire
			const item = {
				value: value,
				expiry: now.getTime() + ttl,
			};
			sessionStorage.setItem(key, JSON.stringify(item));
		},
		closeRegistration() {
			this.registerOpen = "false";
			this.register.reset();
		},
		async loginUser() {
			var query, api;
			api = this.api + this.prefix + "/login";
			query = await this.postLogin(api, this.login);
			// console.log("[loginUser] full query object:", JSON.stringify(query));
			// Guard: response must be a plain object, not HTML/string
			if (typeof query.response !== "object" || query.response === null) {
				this.showError("API configuration error: build the app again", 500);
				return;
			}
			this.message = query.response.message;
			this.http_code = query.code;
			if (query.result == "success") {
				// perform other actions
				this.setAuth("auth", true, 28800000);
				sessionStorage.setItem("access_token", query.response.access_token);
				this.user = query.response.data ?? query.response.user ?? null;
				if (!this.user || !this.user.id) {
					this.showError("Login failed: unexpected server response", 500);
					return;
				}
				sessionStorage.setItem("user_id", this.user.id);
				this.login.reset();
				this.$router.push("/dash").then(() => {
					this.$router.go();
					this.showMessage("Welcome " + this.user?.name);
				});
			} else {
				this.showError(this.message, this.http_code);
			}
		},
		async checkLogin() {
			var user_id = sessionStorage.getItem("user_id");
			var auth = sessionStorage.getItem("auth");
			// var query, api;
			let api = this.api + this.prefix + "/check";
			const query = await this.getData(api);
			this.message = query.response.message;
			this.http_code = query.code;
			if (query.result == "success") {
				// perform other actions
				if (user_id !== null && auth !== null) {
					this.$router.push("/dash");
				}
			} else {
				sessionStorage.clear();
				sessionStorage.clear();

				this.showError(this.message, this.http_code);
			}
		},
		validateString(data) {
			const base64Regex = /^[A-Za-z0-9+/=]+$/;
			return base64Regex.test(data);
		},
		resetPassword() {
			// var query, api;
			let api = this.api + this.prefix + "/forgot";
			const query = this.postData(api, this.reset);
			if (query.result == "success") {
				this.message = query.response.message;
				this.http_code = query.code;
				// perform other actions
				this.$swal({
					text: this.message,
					icon: "success",
					position: "top-end",
					background: "#52BE80",
				});

				this.reset.reset();
				this.passwordOpen = "false";
			}

			if (query.result == "fail") {
				this.message = query.response.message;
				this.http_code = query.code;
				this.$swal({
					text: "Error " + this.http_code + ": " + this.message,
					icon: "error",
					position: "bottom-end",
					background: "#E74C3C",
					timer: 7500,
				});
			}
		},
	},
	created() {},
	beforeMount() {
		// this.checkLogin();
	},
	mounted() {
		localStorage.clear();
		sessionStorage.clear();
		// this.getCookie();
	},
	unmounted() {
		// document.body.classList.remove("back-image");
	},
};
</script>

<style scoped>
/* Container */
.login-container {
	display: flex;
	height: 100vh;
	width: 100%;
	overflow: hidden;
}

/* Left Panel - Branding */
.left-panel {
	flex: 1;
	background: linear-gradient(135deg, #526635 0%, #526635 100%);
	position: relative;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 3rem;
}

.branding-content {
	position: relative;
	z-index: 10;
	color: white;
	max-width: 500px;
	animation: slideInLeft 0.8s ease-out;
}

.logo-section {
	text-align: center;
	margin-bottom: 3rem;
}

.brand-logo {
	width: 120px;
	height: 120px;
	margin-bottom: 1.5rem;
	animation: fadeInScale 1s ease-out;
	filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.2));
	border-radius: 50%;
	background: white;
	padding: 15px;
	object-fit: contain;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.brand-title {
	font-size: 2.5rem;
	font-weight: 700;
	margin-bottom: 0.5rem;
	text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.brand-subtitle {
	font-size: 1.1rem;
	opacity: 0.9;
	margin-bottom: 0;
}

.features-section {
	margin-top: 3rem;
}

.feature-item {
	display: flex;
	align-items: flex-start;
	margin-bottom: 2rem;
	animation: fadeInUp 0.8s ease-out backwards;
}

.feature-item:nth-child(1) {
	animation-delay: 0.2s;
}
.feature-item:nth-child(2) {
	animation-delay: 0.4s;
}
.feature-item:nth-child(3) {
	animation-delay: 0.6s;
}

.feature-icon {
	width: 50px;
	height: 50px;
	background: rgba(255, 255, 255, 0.15);
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 1.25rem;
	backdrop-filter: blur(10px);
	transition: all 0.3s ease;
}

.feature-icon i {
	font-size: 1.5rem;
}

.feature-item:hover .feature-icon {
	transform: scale(1.1) rotate(5deg);
	background: rgba(255, 255, 255, 0.25);
}

.feature-text h3 {
	font-size: 1.1rem;
	font-weight: 600;
	margin-bottom: 0.25rem;
}

.feature-text p {
	font-size: 0.9rem;
	opacity: 0.85;
	margin: 0;
}

/* Decorative Elements */
.decorative-elements {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	pointer-events: none;
	z-index: 1;
}

.circle {
	position: absolute;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.1);
	animation: float 6s ease-in-out infinite;
}

.circle-1 {
	width: 300px;
	height: 300px;
	top: -100px;
	right: -100px;
	animation-delay: 0s;
}

.circle-2 {
	width: 200px;
	height: 200px;
	bottom: 50px;
	left: -50px;
	animation-delay: 2s;
}

.circle-3 {
	width: 150px;
	height: 150px;
	top: 50%;
	right: 10%;
	animation-delay: 4s;
}

/* Right Panel - Form */
.right-panel {
	flex: 1;
	background: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2rem;
	position: relative;
}

.login-form-container {
	width: 100%;
	max-width: 450px;
	animation: slideInRight 0.8s ease-out;
}

.form-header {
	margin-bottom: 2.5rem;
}

.form-title {
	font-size: 2rem;
	font-weight: 700;
	color: #2c3e50;
	margin-bottom: 0.5rem;
}

.form-subtitle {
	font-size: 0.95rem;
	color: #6c757d;
	margin: 0;
}

.login-form {
	margin-bottom: 2rem;
}

.form-group {
	margin-bottom: 1.5rem;
}

.form-label {
	display: block;
	font-size: 0.9rem;
	font-weight: 600;
	color: #2c3e50;
	margin-bottom: 0.5rem;
}

.error-message {
	color: #dc3545;
	font-size: 0.85rem;
	margin-top: -0.25rem;
	margin-bottom: 0.5rem;
}

.modern-input {
	transition: all 0.3s ease;
}

.modern-input:focus-within {
	transform: translateY(-2px);
}

.form-options {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 2rem;
	font-size: 0.9rem;
}

.remember-me {
	display: flex;
	align-items: center;
	cursor: pointer;
	color: #526635;
}

.remember-me input[type="checkbox"] {
	margin-right: 0.5rem;
	cursor: pointer;
	width: 16px;
	height: 16px;
}

.forgot-link {
	color: #526635;
	text-decoration: none;
	font-weight: 500;
	transition: all 0.3s ease;
}

.forgot-link:hover {
	color: #526635;
	text-decoration: underline;
}

.login-button {
	width: 100%;
	padding: 1rem 2rem;
	background: linear-gradient(135deg, #526635 0%, #526635 100%);
	color: white;
	border: none;
	border-radius: 12px;
	font-size: 1rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.3s ease;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
	box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.login-button:hover {
	transform: translateY(-2px);
	box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
}

.login-button:active {
	transform: translateY(0);
}

.login-button i {
	font-size: 1.2rem;
	transition: transform 0.3s ease;
}

.login-button:hover i {
	transform: translateX(4px);
}

.form-footer {
	text-align: center;
	margin-top: 2rem;
}

.system-info {
	font-size: 0.85rem;
	color: #6c757d;
	margin: 0;
}

/* Animations */
@keyframes slideInLeft {
	from {
		opacity: 0;
		transform: translateX(-50px);
	}
	to {
		opacity: 1;
		transform: translateX(0);
	}
}

@keyframes slideInRight {
	from {
		opacity: 0;
		transform: translateX(50px);
	}
	to {
		opacity: 1;
		transform: translateX(0);
	}
}

@keyframes fadeInScale {
	from {
		opacity: 0;
		transform: scale(0.8);
	}
	to {
		opacity: 1;
		transform: scale(1);
	}
}

@keyframes fadeInUp {
	from {
		opacity: 0;
		transform: translateY(20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

@keyframes float {
	0%,
	100% {
		transform: translateY(0) rotate(0deg);
	}
	50% {
		transform: translateY(-20px) rotate(10deg);
	}
}

/* Responsive Design */
@media (max-width: 992px) {
	.login-container {
		flex-direction: column;
	}

	.left-panel {
		min-height: 40vh;
		padding: 2rem;
	}

	.features-section {
		display: none;
	}

	.brand-title {
		font-size: 2rem;
	}

	.right-panel {
		min-height: 60vh;
	}
}

@media (max-width: 576px) {
	.left-panel {
		min-height: 30vh;
		padding: 1.5rem;
	}

	.brand-logo {
		width: 80px;
		height: 80px;
	}

	.brand-title {
		font-size: 1.5rem;
	}

	.brand-subtitle {
		font-size: 0.9rem;
	}

	.login-form-container {
		padding: 1rem;
	}

	.form-title {
		font-size: 1.5rem;
	}
}

/* Vuetify Overrides */
.v-input__details {
	display: none !important;
}

.v-field--variant-outlined .v-field__outline {
	color: #dee2e6;
}

.v-field--focused .v-field__outline {
	color: #28a745 !important;
}
</style>
